import { Fragment, useContext, useEffect, useMemo, useState } from "react";
import classes from "./ThemeNavigation.module.css";
import AuthContext from "../../../store/adminStore/admin-auth-context";
import { styled } from "@mui/material/styles";
import MuiAccordion from "@mui/material/Accordion";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import MuiAccordionSummary from "@mui/material/AccordionSummary";
import MuiAccordionDetails from "@mui/material/AccordionDetails";
import Typography from "@mui/material/Typography";
import { NavLink, useLocation } from "react-router-dom";
const Accordion = styled((props) => <MuiAccordion disableGutters elevation={0} square {...props} />)(
  ({ theme }) => ({
    color: "inherit !important",
    backgroundColor: "transparent !important",
    paddingInline: "12px",
    border: `none`,
    "&:not(:last-child)": {
      borderBottom: 0,
    },
    "&:before": {
      display: "none",
    },
  })
);
const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
  padding: theme.spacing(2),
  borderTop: "none",
}));
const AccordionSummary = styled((props) => {
  // console.log(props.items);
  return (
    <MuiAccordionSummary expandIcon={props.items.length !== 0 ? <ExpandMoreIcon /> : null} {...props} />
  );
})(({ theme }) => ({
  backgroundColor: "transparent",

  "& .MuiAccordionSummary-expandIconWrapper.Mui-expanded": {
    transform: "rotate(180deg)",
  },
  "& .MuiAccordionSummary-content": {
    marginLeft: theme.spacing(1),
  },
}));
const RecursiveComponent = ({ theme, navItem, systemActiveNames, setThemeOpenSidebar }) => {
  const location = useLocation();
  const [subExpanded, setSubExpanded] = useState(location.pathname);
  const { clientAuthInfo } = useContext(AuthContext);
  const closeSidebarOnMobileHandler = (e) => {
    const viewportWidth = window.innerWidth;
    if (viewportWidth < 1200) {
      setThemeOpenSidebar(false);
    }
  };
  const handleSubChange = (panel) => (event, newExpanded) => {
    setSubExpanded(newExpanded ? panel : false);
  };
  const allAccessbleEntities = clientAuthInfo.accessibilities
    .filter((which) => systemActiveNames.includes(which.packageName))
    .map((each) => each.selectAccessList)
    .flat(1);

  return (
    <Fragment>
      {navItem.items.map((na) => {
        return (
          <div key={na.id}>
            {na.items.length === 0 ? (
              allAccessbleEntities.includes(na.name) ? (
                <NavLink
                  key={na.id}
                  to={na.to}
                  onClick={closeSidebarOnMobileHandler}
                  className={({ isActive }) =>
                    [
                      isActive
                        ? theme === "Dark"
                          ? classes.activeLinkDarkTheme
                          : classes.activeLinkBrightTheme
                        : classes.unActiveLink,
                      isActive
                        ? theme === "White"
                          ? classes.whiteThemeActiveDot
                          : theme === "Pink"
                          ? classes.pinkThemeActiveDot
                          : theme === "Gradient"
                          ? classes.gradientThemeActiveDot
                          : theme === "Dark"
                          ? classes.darkThemeActiveDot
                          : theme === "Blue"
                          ? classes.BlueThemeActiveDot
                          : null
                        : null,
                    ].join(" ")
                  }
                  // onClick={(e) => handleExp(e, na.to)}
                >
                  <AccordionDetails
                    className={classes.nestedLink}
                    sx={{ paddingInlineStart: "48px", transition: "all 0.3s ease-out" }}
                  >
                    {allAccessbleEntities.includes(na.name) ? na.label : null}
                  </AccordionDetails>
                </NavLink>
              ) : null
            ) : allAccessbleEntities.some((nav) => na.containerOfEntitys.includes(nav)) ? (
              <Accordion expanded={subExpanded === na.to} onChange={handleSubChange(na.to)}>
                <AccordionSummary aria-controls="panel2d-content" id="panel2d-header" items={na.items}>
                  <Typography
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      transition: "all 0.3s ease-out !important",
                    }}
                    className={
                      subExpanded === na.to
                        ? theme === "Dark"
                          ? classes.activeUCDarkTheme
                          : classes.activeUCBrightTheme
                        : null
                    }
                  >
                    <span
                      style={{
                        paddingInlineEnd: "12px",
                        transition: "all 0.3s ease-out !important",
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      {na.icon}
                    </span>
                    {na.label}
                  </Typography>
                </AccordionSummary>
                <RecursiveComponent
                  navItem={na}
                  systemActiveNames={systemActiveNames}
                  setThemeOpenSidebar={setThemeOpenSidebar}
                  theme={theme}
                />
              </Accordion>
            ) : null}
          </div>
        );
      })}
    </Fragment>
  );
};

export default RecursiveComponent;
